import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "pb-10 pb-lg-15" }
const _hoisted_3 = { class: "fw-bolder d-flex align-items-center text-dark" }
const _hoisted_4 = { class: "text-gray-600 fw-bold fs-6" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "fv-row" }
const _hoisted_7 = {
  key: 0,
  class: "col-lg-12 fv-row"
}
const _hoisted_8 = { class: "text-decoration-underline" }
const _hoisted_9 = { class: "col-lg-12 fv-row" }
const _hoisted_10 = { class: "d-flex align-items-center fs-6 mb-2 text-dark-blue" }
const _hoisted_11 = ["title"]
const _hoisted_12 = ["title"]
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "row mb-2" }
const _hoisted_15 = { class: "col-auto" }
const _hoisted_16 = { class: "form-check form-check-inline form-check-solid me-5" }
const _hoisted_17 = ["value", "onUpdate:modelValue"]
const _hoisted_18 = { class: "fw-bold ps-2 fs-6" }
const _hoisted_19 = { class: "fv-plugins-message-container" }
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "col-auto" }
const _hoisted_22 = { class: "form-check form-check-inline form-check-solid me-5" }
const _hoisted_23 = ["value", "onUpdate:modelValue"]
const _hoisted_24 = { class: "fw-bold ps-2 fs-6" }
const _hoisted_25 = { class: "col-auto" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { key: 3 }
const _hoisted_28 = { class: "row mb-2" }
const _hoisted_29 = { class: "col-lg-2 col-form-label fw-bold fs-6" }
const _hoisted_30 = { class: "col-lg-3" }
const _hoisted_31 = { class: "fv-plugins-message-container" }
const _hoisted_32 = { class: "fv-help-block" }
const _hoisted_33 = { class: "col-lg-2 col-form-label fw-bold fs-6" }
const _hoisted_34 = { class: "col-lg-3" }
const _hoisted_35 = { class: "fv-plugins-message-container" }
const _hoisted_36 = { class: "fv-help-block" }
const _hoisted_37 = { key: 4 }
const _hoisted_38 = { class: "row mb-2" }
const _hoisted_39 = { class: "col-lg-2 col-form-label fw-bold fs-6" }
const _hoisted_40 = { class: "col-lg-6" }
const _hoisted_41 = { class: "fv-plugins-message-container" }
const _hoisted_42 = { class: "fv-help-block" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1 d-flex justify-content-center flex-column" }, [
  /*#__PURE__*/_createElementVNode("div", null, "%")
], -1)
const _hoisted_44 = { key: 5 }
const _hoisted_45 = { class: "row mb-2" }
const _hoisted_46 = { class: "col-lg-12" }
const _hoisted_47 = ["onUpdate:modelValue"]
const _hoisted_48 = { class: "fv-plugins-message-container" }
const _hoisted_49 = { class: "fv-help-block" }
const _hoisted_50 = {
  key: 6,
  class: "text-danger d-flex flex-column"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_integer_gender_field = _resolveComponent("integer-gender-field")!
  const _component_select_yes_no_field = _resolveComponent("select-yes-no-field")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.step[_ctx.translateKey("descrizione")]), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.translate("SURVEY_OPTIONALITY_MESSAGE")), 1),
      _createElementVNode("div", {
        class: "text-gray-600 fw-bold fs-6 mt-5",
        innerHTML: _ctx.translate(_ctx.messages_survey[_ctx.step.id - 1])
      }, null, 8, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.input_values_reduce, (input, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "row mb-6",
          key: index
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SurveyService.getInputByIdGroup(
            input.input.set_id,
            input.input.id,
            _ctx.input_values_in_step
          ), (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              (
              _ctx.SurveyService.isInArray(
                _ctx.setsHeaderList,
                'after_kpi_number',
                item.kpi.auto_number
              )?.after_kpi_number > 0
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.SurveyService.isInArray(
                  _ctx.setsHeaderList,
                  "after_kpi_number",
                  item.kpi.auto_number
                )[_ctx.translateKey("message")]), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, [
              _createElementVNode("span", {
                class: _normalizeClass(!input.kpi.optional ? 'required' : '')
              }, _toDisplayString(input.kpi.set_id) + "." + _toDisplayString(input.kpi.id) + " " + _toDisplayString(input.kpi[_ctx.translateKey("name")]), 3),
              (input.kpi.description != 'VOID')
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: "fas fa-exclamation-circle ms-2 fs-7",
                    "data-bs-toggle": "tooltip",
                    title: input.kpi[_ctx.translateKey('description')]
                  }, null, 8, _hoisted_11))
                : _createCommentVNode("", true),
              _createElementVNode("i", {
                class: "fas fa-save ms-2 fs-7",
                "data-bs-toggle": "tooltip",
                title: 
                _ctx.translate('SURVEY_LAST_MODIFIED_BY') +
                ' `' +
                _ctx.currentUser.user_name +
                '` (' +
                _ctx.currentUser.email +
                ') ' +
                _ctx.translate('SURVEY_TIME_LAST_MODIFICATION') +
                ' ' +
                input.input.timestamp_modification
              
              }, null, 8, _hoisted_12)
            ])
          ]),
          (input.kpi.type == _ctx.InputTypes.INTEGER_GENDER_FIELD)
            ? (_openBlock(), _createBlock(_component_integer_gender_field, {
                key: 0,
                input: input,
                input_values_in_step: _ctx.input_values_in_step
              }, null, 8, ["input", "input_values_in_step"]))
            : _createCommentVNode("", true),
          (input.kpi.type == _ctx.InputTypes.SELECT_YES_NO_FIELD)
            ? (_openBlock(), _createBlock(_component_select_yes_no_field, {
                key: 1,
                input: input,
                input_values_in_step: _ctx.input_values_in_step
              }, null, 8, ["input", "input_values_in_step"]))
            : _createCommentVNode("", true),
          (input.kpi.type == _ctx.InputTypes.ROLE_GENDER_FIELD)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_Field, {
                    class: "form-check-input d-none",
                    type: "text",
                    name: 'input' + input.kpi.auto_number,
                    modelValue: input.input.value,
                    "onUpdate:modelValue": ($event: any) => ((input.input.value) = $event)
                  }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        value: _ctx.InputTypes.VALUE_WOMAN_FIELD,
                        "onUpdate:modelValue": ($event: any) => ((input.input.value) = $event)
                      }, null, 8, _hoisted_17), [
                        [_vModelRadio, input.input.value]
                      ]),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.translate("SURVEY_WOMEN_STRING")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_ErrorMessage, {
                          name: 'input' + input.kpi.auto_number
                        }, null, 8, ["name"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("label", _hoisted_22, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        value: _ctx.InputTypes.VALUE_MAN_FIELD,
                        "onUpdate:modelValue": ($event: any) => ((input.input.value) = $event)
                      }, null, 8, _hoisted_23), [
                        [_vModelRadio, input.input.value]
                      ]),
                      _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.translate("SURVEY_MEN_STRING")), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("i", {
                      class: "fas fa-eraser ms-1 fs-2",
                      "data-bs-toggle": "tooltip",
                      title: "Info",
                      onClick: ($event: any) => (input.input.value = '')
                    }, null, 8, _hoisted_26)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (input.kpi.type == _ctx.InputTypes.FLOAT_GENDER_FIELD)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.translate("SURVEY_WOMEN_STRING")), 1),
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_Field, {
                      type: "number",
                      min: "0",
                      name: 
                  'input' +
                  _ctx.SurveyService.getSingleFloatIntegerGenderField(
                    input.input.set_id,
                    input.input.id,
                    _ctx.InputTypes.FLOAT_WOMEN_SUB_ID,
                    _ctx.input_values_in_step
                  ).kpi.auto_number
                ,
                      class: "form-control form-control-lg",
                      modelValue: 
                  _ctx.SurveyService.getSingleFloatIntegerGenderField(
                    input.input.set_id,
                    input.input.id,
                    _ctx.InputTypes.FLOAT_WOMEN_SUB_ID,
                    _ctx.input_values_in_step
                  ).input.value
                ,
                      "onUpdate:modelValue": ($event: any) => ((
                  _ctx.SurveyService.getSingleFloatIntegerGenderField(
                    input.input.set_id,
                    input.input.id,
                    _ctx.InputTypes.FLOAT_WOMEN_SUB_ID,
                    _ctx.input_values_in_step
                  ).input.value
                ) = $event)
                    }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_ErrorMessage, {
                          name: 
                      'input' +
                      _ctx.SurveyService.getSingleFloatIntegerGenderField(
                        input.input.set_id,
                        input.input.id,
                        _ctx.InputTypes.FLOAT_WOMEN_SUB_ID,
                        _ctx.input_values_in_step
                      ).kpi.auto_number
                    
                        }, null, 8, ["name"])
                      ])
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.translate("SURVEY_MEN_STRING")), 1),
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_Field, {
                      type: "number",
                      min: "0",
                      name: 
                  'input' +
                  _ctx.SurveyService.getSingleFloatIntegerGenderField(
                    input.input.set_id,
                    input.input.id,
                    _ctx.InputTypes.FLOAT_MEN_SUB_ID,
                    _ctx.input_values_in_step
                  ).kpi.auto_number
                ,
                      class: "form-control form-control-lg",
                      modelValue: 
                  _ctx.SurveyService.getSingleFloatIntegerGenderField(
                    input.input.set_id,
                    input.input.id,
                    _ctx.InputTypes.FLOAT_MEN_SUB_ID,
                    _ctx.input_values_in_step
                  ).input.value
                ,
                      "onUpdate:modelValue": ($event: any) => ((
                  _ctx.SurveyService.getSingleFloatIntegerGenderField(
                    input.input.set_id,
                    input.input.id,
                    _ctx.InputTypes.FLOAT_MEN_SUB_ID,
                    _ctx.input_values_in_step
                  ).input.value
                ) = $event)
                    }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_ErrorMessage, {
                          name: 
                      'input' +
                      _ctx.SurveyService.getSingleFloatIntegerGenderField(
                        input.input.set_id,
                        input.input.id,
                        _ctx.InputTypes.FLOAT_MEN_SUB_ID,
                        _ctx.input_values_in_step
                      ).kpi.auto_number
                    
                        }, null, 8, ["name"])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (input.kpi.type == _ctx.InputTypes.PERCENTAGE_FIELD)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.translate("SURVEY_WOMEN_STRING")), 1),
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: 'input' + input.kpi.auto_number,
                      class: "form-control form-control-lg",
                      modelValue: input.input.value,
                      "onUpdate:modelValue": ($event: any) => ((input.input.value) = $event)
                    }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _createVNode(_component_ErrorMessage, {
                          name: 'input' + input.kpi.auto_number
                        }, null, 8, ["name"])
                      ])
                    ])
                  ]),
                  _hoisted_43
                ])
              ]))
            : _createCommentVNode("", true),
          (input.kpi.type == _ctx.InputTypes.TEXT_AREA_FIELD)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createVNode(_component_Field, {
                      class: "form-check-input d-none",
                      type: "text",
                      name: 'input' + input.kpi.auto_number,
                      modelValue: input.input.value,
                      "onUpdate:modelValue": ($event: any) => ((input.input.value) = $event)
                    }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                    _withDirectives(_createElementVNode("textarea", {
                      class: "form-control form-control-lg",
                      "onUpdate:modelValue": ($event: any) => ((input.input.value) = $event),
                      rows: "5"
                    }, "\r\n              ", 8, _hoisted_47), [
                      [_vModelText, input.input.value]
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _createVNode(_component_ErrorMessage, {
                          name: 'input' + input.kpi.auto_number
                        }, null, 8, ["name"])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.getErrors(input.kpi.id).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getErrors(input.kpi.id), (error, error_index) => {
                  return (_openBlock(), _createElementBlock("small", { key: error_index }, _toDisplayString(error[_ctx.translateKey("error")]), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}